const Footer = () => {
    return (
      <footer className="container-fluid pt-4">
        <small>
        <p> &copy; {new Date().getFullYear().toString()} Demoshop by Hans Ophüls</p>
        </small>
      </footer>
    );
  };
  
  export default Footer;
  